// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"121cc24c7f3fb4f52a08","883":"91dfbc60bcd0cc15297d"}[chunkId] + ".js";
};